/**
 * The property wizard is for a first invite that has never become an account.
 * A homeowner who already signed in (active, or account_created) reloads onto
 * the dashboard even when onboarding_completed was never set.
 * Password reset stays on the dashboard so the reset form can show.
 * A setup that was left unfinished (resume) comes back, including after a
 * sign-out, until Done or Skip marks it complete.
 */
const SETUP_RESUME_PREFIX = 'pacarion_setup_resume_';

function setupResumeKey(clientId) {
  return `${SETUP_RESUME_PREFIX}${clientId || ''}`;
}

function readSetupResume(storage, clientId) {
  if (!storage || !clientId) return false;
  try {
    return storage.getItem(setupResumeKey(clientId)) === '1';
  } catch (error) {
    return false;
  }
}

function writeSetupResume(storage, clientId, active) {
  if (!storage || !clientId) return;
  try {
    if (active) storage.setItem(setupResumeKey(clientId), '1');
    else storage.removeItem(setupResumeKey(clientId));
  } catch (error) {
    // A blocked write still leaves the in-memory wizard in place.
  }
}

function shouldShowPropertySetup(client, options) {
  if (!client || client.password_reset_required || client.onboarding_completed) return false;
  if (options && options.resume) return true;
  if (client.status === 'active' || client.account_created) return false;
  return true;
}

/** A dead token signs the homeowner out. A network or server error does not. */
function sessionLostOnLoadError(error) {
  return Boolean(error && Number(error.status) === 401);
}

module.exports = {
  setupResumeKey,
  readSetupResume,
  writeSetupResume,
  shouldShowPropertySetup,
  sessionLostOnLoadError,
};
